import { createElementBlock as c, openBlock as e, createElementVNode as o } from "vue";
import r from "./index289.js";
const l = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(a, t, p, m, f, i) {
  return e(), c("svg", n, t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      d: "M9 2.25c3.052 0 5.601.985 5.743 2.606l.003.07A.76.76 0 0 1 14.75 5v3.985l.001.015-.001.021v2.528a5.251 5.251 0 1 1-2.66 7.802c-.904.258-1.972.399-3.09.399-3.141 0-5.748-1.043-5.75-2.75V4.999C3.253 3.294 5.861 2.25 9 2.25Zm4.848 11.598a3.752 3.752 0 0 0-.752 4.228.55.55 0 0 1 .05.1l.076.146a3.75 3.75 0 1 0 5.93-4.474l-.155-.146a3.75 3.75 0 0 0-5.149.146ZM4.75 14.92V17c0 .503 1.869 1.25 4.25 1.25a10.2 10.2 0 0 0 2.46-.283 5.252 5.252 0 0 1-.12-2.435c-.722.142-1.518.218-2.34.218-1.672 0-3.193-.296-4.25-.83ZM9 11.75c-1.673 0-3.195-.296-4.252-.83l.001 2.046.001.034c0 .503 1.868 1.25 4.249 1.25 1.124 0 2.178-.16 2.989-.434a5.184 5.184 0 0 1 1.26-1.44l.002-1.455c-1.057.534-2.578.829-4.25.829Zm4.25-4.83c-1 .506-2.416.798-3.983.827L9 7.75c-1.672 0-3.193-.295-4.25-.83v2.054L4.752 9c0 .503 1.868 1.25 4.25 1.25 2.382 0 4.25-.747 4.25-1.25V6.92ZM9 3.75c-2.372 0-4.237.743-4.25 1.245v.012C4.75 5.503 6.618 6.25 9 6.25c2.382 0 4.25-.747 4.25-1.25 0-.485-1.743-1.199-4.006-1.247L9 3.75Z"
    }, null, -1)
  ]));
}
const v = /* @__PURE__ */ r(l, [["render", s]]);
export {
  v as default
};
